/* unplugin-vue-components disabled */import script from "./MapGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./MapGenerator.vue?vue&type=script&setup=true&lang=js"

import "./MapGenerator.vue?vue&type=style&index=0&id=e22f33c8&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e22f33c8"]])

export default __exports__